module.exports = __webpack_public_path__ + "media/images/mobility/electron-388e95874a6ce1e40ffef15aa4b741f5.svg";